import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import ReactTable from 'react-table';
import moment from 'moment';
import matchSorter from 'match-sorter';
import memoize from 'memoizee';
import queryString from 'query-string';

import {
  Input,
  Button,
  Row,
  Col,
  Select,
  SelectOption,
  Switch,
} from 'components/ui';
import { Loading } from 'components/blocks';
import 'material-icons-font/material-icons-font.css';
// import { Loading } from 'components/blocks';
import DateRangePicker from 'components/blocks/DateRangePicker';
import TablePagination from 'components/ui/TablePagination';
import { showErrorNotification } from 'services/common';
import makeData from './makeData';
import 'assets/css/react-table.css';
import './style.css';

// const errorMessage = 'Unable to complete request. Please try again later.';

class Perf extends Component {
  marshallTotals = memoize(dataSet => {
    return (
      dataSet &&
      dataSet.reduce((acc, n) => {
        Object.keys(n).forEach(prop => {
          if (Number.isNaN(acc[prop]) || !acc[prop]) acc[prop] = 0;
          if (typeof n[prop] === 'number') acc[prop] += n[prop];
        });
        return acc;
      }, {})
    );
  });

  constructor(props) {
    super(props);
    this.reactTable = null;

    this.state = {
      /* isLoading: false,
      error: '', */
      data: [],
      filtered: [],
      filterAll: '',
      startDate: moment().startOf('month'),
      endDate: moment(),
      hideDuration: true,
      selectedCategoryId: -1,
      realTimeData: true,
    };
  }

  async componentDidMount() {
    const { onGetCategories } = this.props;
    onGetCategories();
    const flags = global.location && queryString.parse(global.location.search);
    const seeded = flags.mode && flags.mode === 'seed';

    if (!seeded) {
      // await this.props.getMetrics(startDate, endDate);
    } else {
      const data = makeData();
      this.setState({
        data,
      });
    }
  }

  componentDidUpdate(prevProps) {
    this.showErrors(prevProps);
  }

  showErrors = prevProps => {
    if (this.props.error && prevProps.error !== this.props.error) {
      showErrorNotification(this.props.error);
    }
  };

  setTableRef = element => {
    this.reactTable = element;
  };

  formatPercentage = (refNumber, val) =>
    refNumber === 0 ? (0).toFixed(1) : ((val * 100) / refNumber).toFixed(1);

  formatField = (refNumber, val) => {
    return typeof val === 'undefined'
      ? '-'
      : `${val || 0} (${this.formatPercentage(refNumber, val)}%)`;
  };

  handleFilteredChange = filtered => {
    if (filtered.length > 1 && this.state.filterAll.length) {
      const filterAll = '';
      this.setState({
        filtered: filtered.filter(item => item.id !== 'all'),
        filterAll,
      });
    } else this.setState({ filtered });
  };

  handleFilterAll = e => {
    const { value } = e.target;
    const filterAll = value;
    const filtered = [{ id: 'all', value: filterAll }];
    this.setState({ filterAll, filtered });
  };

  handleSelectionChange = event => {
    const { visible } = this.state;
    const { id } = event.currentTarget;
    visible[id] = !visible[id];

    this.setState({
      visible,
    });
  };

  handleSummarySwitchChange = checked => {
    this.setState({ realTimeData: checked });
  };

  handleDateRangeChange = async dates => {
    this.props.setDuration([dates[0].format(), dates[1].format()]);
    this.setState({ hideDuration: false });

    this.setState({
      startDate: dates[0],
      endDate: dates[1],
    });
  };

  handleLoadDataClick = () => {
    const { startDate, endDate, selectedCategoryId, realTimeData } = this.state;

    const flags = global.location && queryString.parse(global.location.search);
    const seeded = flags.mode && flags.mode === 'seed';
    if (!seeded) {
      this.props.getMetrics(
        startDate,
        endDate,
        selectedCategoryId,
        realTimeData,
      );
    }
  };

  handleClickRow = (state, rowInfo) => ({
    onClick: () =>
      this.props.history.push(
        `/performance/templates/${rowInfo.original.id}/${rowInfo.original.name}`,
      ),
  });

  handleCategoryChange = value => {
    this.setState({
      selectedCategoryId: value,
    });
  };

  renderMetrics() {
    const flags = global.location && queryString.parse(global.location.search);
    const seeded = flags.mode && flags.mode === 'seed';
    const { metrics } = this.props;
    const { data } = this.state;
    const totals = this.marshallTotals(metrics);

    if (metrics.length === 0) {
      return (
        <div style={{ padding: '30px' }}>
          <h4>
            Empty data set, select a date range or a template category and click
            load
          </h4>
        </div>
      );
    }

    return (
      <ReactTable
        PaginationComponent={TablePagination}
        className="-highlight"
        columns={[
          {
            Header: 'id',
            accessor: 'id',
            show: false,
          },
          {
            Header: 'Template Name',
            id: 'name',
            accessor: 'name',
            Footer: 'Total',
          },
          {
            Header: 'Sent',
            id: 'sent',
            accessor: 'sent',
            Footer: <span>{totals.sent}</span>,
          },
          {
            Header: 'Delivered',
            id: 'delivered',
            accessor: d => this.formatField(d.sent, d.delivered),
            Footer: (
              <span>{this.formatField(totals.sent, totals.delivered)}</span>
            ),
          },
          {
            Header: 'Opened',
            id: 'total_open',
            accessor: d => this.formatField(d.sent, d.total_open),
            Footer: (
              <span>{this.formatField(totals.sent, totals.total_open)}</span>
            ),
          },
          {
            Header: 'Open.(uniq.)',
            id: 'unique_open',
            accessor: d => this.formatField(d.sent, d.unique_open),
            Footer: (
              <span>{this.formatField(totals.sent, totals.unique_open)}</span>
            ),
          },
          {
            Header: 'Reply',
            id: 'reply_count',
            accessor: d => this.formatField(d.sent, d.reply_count),
            Footer: (
              <span>{this.formatField(totals.sent, totals.reply_count)}</span>
            ),
          },
          {
            Header: 'Clickthrough',
            id: 'clickthrough',
            accessor: d => this.formatField(d.sent, d.clickthrough),
            Footer: (
              <span>{this.formatField(totals.sent, totals.clickthrough)}</span>
            ),
          },
          {
            Header: 'Clickthrough.(uniq.)',
            id: 'unique_click',
            accessor: d => this.formatField(d.sent, d.unique_click),
            Footer: (
              <span>{this.formatField(totals.sent, totals.unique_click)}</span>
            ),
          },
          {
            Header: 'Unsubscribed',
            id: 'unsubscription_count',
            accessor: d => this.formatField(d.sent, d.unsubscription_count),
            Footer: (
              <span>
                {this.formatField(totals.sent, totals.unsubscription_count)}
              </span>
            ),
          },
          {
            Header: 'Spam',
            id: 'spam_count',
            accessor: d => this.formatField(d.sent, d.spam_count),
            Footer: (
              <span>{this.formatField(totals.sent, totals.spam_count)}</span>
            ),
          },
          {
            Header: 'Hard bounce',
            id: 'bounce_count',
            accessor: d => this.formatField(d.sent, d.bounce_count),
            Footer: (
              <span>{this.formatField(totals.sent, totals.bounce_count)}</span>
            ),
          },
          /*
          {
            Header: 'Soft bounce',
            id: 'soft_bounce',
            accessor: d => this.formatField(d.sent, d.soft_bounce),
            Footer: (
              <span>
                {localTotals.soft_bounce || (totals && totals.soft_bounce)}
              </span>
            ),
          },
          */
          {
            // "filter all" dummy column
            Header: '',
            id: 'all',
            width: 0,
            resizable: false,
            sortable: false,
            show: false,
            Filter: () => {},
            getProps: () => {},
            filterMethod: (filter, rows) => {
              // using match-sorter
              const result = matchSorter(rows, filter.value, {
                keys: ['name'],
                threshold: matchSorter.rankings.WORD_STARTS_WITH,
              });
              return result;
            },
            filterAll: true,
          },
        ]}
        data={seeded ? data : metrics}
        defaultPageSize={10}
        filtered={this.state.filtered}
        firstText={<i className="material-icons">first_page</i>}
        // eslint-disable-next-line react/jsx-handler-names
        getTrProps={this.handleClickRow}
        lastText={<i className="material-icons">last_page</i>}
        minRows={0}
        nextText={<i className="material-icons">chevron_right</i>}
        previousText={<i className="material-icons">chevron_left</i>}
        ref={this.setTableRef}
        rowsSelectorText="Rows per page"
        showPageJump={false}
        showPaginationBottom
        onFilteredChange={this.handleFilteredChange}
      />
    );
  }

  renderRealTimeReminder() {
    const { realTimeData } = this.state;
    return (
      realTimeData && (
        <span style={{ fontSize: '9px', padding: '9px' }}>
          Real time data is only available for 62 days
        </span>
      )
    );
  }

  render() {
    const { isLoading, categories, isFetchingMetrics } = this.props;
    const { startDate, endDate, hideDuration, selectedCategoryId } = this.state;
    return (
      <div className="performance-body">
        <header>
          <Row>
            <Col span={16}>
              <h2>Performance Marketing Team {isLoading && <Loading />}</h2>
            </Col>
            <Col span={8}>
              <Switch
                checkedChildren="Real time"
                defaultChecked
                unCheckedChildren="Summary"
                onChange={this.handleSummarySwitchChange}
              />
              {this.renderRealTimeReminder()}
            </Col>
          </Row>
        </header>
        <Row>
          <Col span={12}>
            <DateRangePicker
              endDate={endDate}
              hideDuration={hideDuration}
              startDate={startDate}
              onDateRangeChange={this.handleDateRangeChange}
            />
          </Col>
          <Col className="performance-page__col" span={5}>
            <h6>&nbsp;</h6>
            <Select
              name="selectedCategoryId"
              value={selectedCategoryId}
              onChange={this.handleCategoryChange}
            >
              <SelectOption key="default" value={-1}>
                All templates
              </SelectOption>
              {categories.map(category => (
                <SelectOption key={category.id} value={category.id}>
                  {category.name}
                </SelectOption>
              ))}
            </Select>
          </Col>
          <Col className="performance-page__col" span={5}>
            <h6>&nbsp;</h6>
            <Button
              className="performance__load-btn"
              type="button"
              onClick={this.handleLoadDataClick}
            >
              Load Data
            </Button>
          </Col>
        </Row>
        <div className="performance-panel">
          <div className="performance-search">
            <i className="material-icons md-24 performance-icon">search</i>
            <Input
              placeholder="Filter..."
              style={{ border: '0' }}
              value={this.state.filterAll}
              onChange={this.handleFilterAll}
            />
          </div>
          {isFetchingMetrics ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 25,
              }}
            >
              <Loading />
            </div>
          ) : (
            this.renderMetrics()
          )}
        </div>
      </div>
    );
  }
}

Perf.defaultProps = {
  isLoading: false,
  metrics: [],
  categories: [],
};

Perf.propTypes = {
  error: PropTypes.string.isRequired,
  getMetrics: PropTypes.func.isRequired,
  isFetchingMetrics: PropTypes.bool,
  onGetCategories: PropTypes.func.isRequired,
  setDuration: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  isLoading: PropTypes.bool,
  metrics: PropTypes.arrayOf(PropTypes.shape({})),
  categories: PropTypes.arrayOf(PropTypes.shape({})),
};

export default withRouter(Perf);
